/**
 * Shared deferred `beforeinstallprompt` for Admin PWA.
 * AdminPwaLifecycle captures the event; Settings gear Install reads the same prompt.
 */

export interface AdminBeforeInstallPromptEvent extends Event {
  readonly prompt: () => Promise<void>;
  readonly userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let deferredPrompt: AdminBeforeInstallPromptEvent | null = null;
const listeners = new Set<() => void>();

function notifyListeners(): void {
  for (const listener of listeners) {
    listener();
  }
}

export function setAdminPwaInstallPrompt(
  event: AdminBeforeInstallPromptEvent | null,
): void {
  deferredPrompt = event;
  notifyListeners();
}

export function peekAdminPwaInstallPrompt(): AdminBeforeInstallPromptEvent | null {
  return deferredPrompt;
}

/** Clears and returns the current prompt (after `prompt()` / dismiss). */
export function takeAdminPwaInstallPrompt(): AdminBeforeInstallPromptEvent | null {
  const current = deferredPrompt;
  deferredPrompt = null;
  notifyListeners();
  return current;
}

export function subscribeAdminPwaInstallPrompt(listener: () => void): () => void {
  listeners.add(listener);
  return (): void => {
    listeners.delete(listener);
  };
}

export function resetAdminPwaInstallPromptStoreForTests(): void {
  deferredPrompt = null;
  listeners.clear();
}
